import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'app-radio-button-group',
    templateUrl: './radio-button-group.component.html',
    styleUrls: ['./radio-button-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        role: 'select'
    },
    standalone: false
})
export class RadioButtonGroupComponent {

  // @deprecated
  @Input() selectedIndex: number;

  @HostBinding('attr.size') @Input() size: string = 'default';

}
